<template>
    <label :for="`product-${group.id}-${product.id}`" class="product-name"> {{ product.name[ lang ] }} </label>


    <div class="actions_group">
        <input
            ref="refInput"
            type="number"
            :min="min"
            :max="max"
            :placeholder="`${min}$`"
            @keyup="onChangeValue"
            class="custom-price cache-bust"
            @change="onChange"
        />
    </div>

    <span class="status-error" v-if="currentValue > 0 && currentValue < min">{{
            errorMinMessage
        }}</span>

    <span class="status-error" v-if="currentValue > 0 && currentValue > max">{{
            errorMaxMessage
        }}</span>

</template>

<script>
export default {
    name : "ProductInput",
}
</script>

<script setup>

import { ref, computed }          from "vue";
import { useMainStore } from "../stores/main";
import { storeToRefs }  from "pinia";

const emits            = defineEmits( [ "change", "validity" ] );
let props              = defineProps( [ "group", "groupIndex", "product", "productIndex", "getOrder", "isOpen", "onOrderChange", "got", "min", "max" ] );
let store              = useMainStore();
let { copydeck, lang } = storeToRefs( store );



let currentValue = ref(  parseInt( props.getOrder( props.product.id ) ) );
let refInput       = ref( null );

let errorMinMessage = computed ( () =>
 {
        let message = copydeck.value.custom_gift_card.error_min[ lang.value ] ?? 'copydeck.custom_gift_card.error_min';

        return message.replace("%s", props.min ?? 1);

 })

let errorMaxMessage = computed ( () =>
 {
     let message = copydeck.value.custom_gift_card.error_max[ lang.value ] ?? 'copydeck.custom_gift_card.error_max';

     return message.replace("%s", props.max ?? 99);

 })
function onChangeValue ( event )
{
    let v = parseInt( refInput.value.value );
    currentValue.value = v;

    // 2023-08-25 MB: We were ending up with too-low giftcards in the order
    if ( v < props.min|| v > props.max )
    {
        emits( "validity", props.product.id, { groupIndex : props.groupIndex, customGiftCard : true, validity: false } );
        emits( "change", props.product.id, { quantity : v, groupIndex : props.groupIndex, customGiftCard : true } );
        return;
    }

    props.onOrderChange( props.product.id, { quantity : v, groupIndex : props.groupIndex , customGiftCard : true} );
    emits( "validity", props.product.id, { groupIndex : props.groupIndex, customGiftCard : true, validity: true } );
    emits( "change", props.product.id, { quantity : v, groupIndex : props.groupIndex, customGiftCard : true } );
}

function onChange ( event )
{
     let v              = parseInt( refInput.value.value );
     currentValue.value = v;

     onChangeValue(event);
    //
    //
    // // 2023-08-25 MB: We were ending up with too-low giftcards in the order
    // if ( v < props.min || v > props.max)
    // {
    //     return;
    // }

    // props.onOrderChange( props.product.id, { quantity : v, groupIndex : props.groupIndex, customGiftCard : true } );
    //
    // emits( "change", props.product.id, { quantity : v, groupIndex : props.groupIndex, customGiftCard : true } );

}

</script>
